import { useUserContext } from '@vp/ubik-context';

const useIsEditMode = () => {
    const userContext = useUserContext();
    return userContext?.queryStrings?.edit === 'true';
};

export default useIsEditMode;
